import { render, staticRenderFns } from "./AddPaymentVoucher.vue?vue&type=template&id=70cc6382"
import script from "./AddPaymentVoucher.vue?vue&type=script&lang=js"
export * from "./AddPaymentVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70cc6382')) {
      api.createRecord('70cc6382', component.options)
    } else {
      api.reload('70cc6382', component.options)
    }
    module.hot.accept("./AddPaymentVoucher.vue?vue&type=template&id=70cc6382", function () {
      api.rerender('70cc6382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/AddPaymentVoucher.vue"
export default component.exports